import {
  AVG_SORT_ORDER,
  DASHBOARD_OVERALL_SCORE_RANGES,
  DEPARTMENT_FILTER,
  DETAILS_INDIVIDUAL_PERFORMANCE_FILTER,
  SCORE_FILTER,
} from "../utilities/constants"

export const IndividualPerformanceFilters = (filterData) => [
  {
    filterKey: DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE,
    filterLabel: "Minimum Score",
    filterValue: filterData?.[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] ?? SCORE_FILTER.ZERO,
    filterOptions: [
      {
        optionValue: SCORE_FILTER.ZERO,
        displayText: "0%",
      },
      {
        optionValue: SCORE_FILTER.TWENTY,
        displayText: "20%",
      },
      {
        optionValue: SCORE_FILTER.FORTY,
        displayText: "40%",
      },
      {
        optionValue: SCORE_FILTER.SIXTY,
        displayText: "60%",
      },
      {
        optionValue: SCORE_FILTER.EIGHTY,
        displayText: "80%",
      },
    ],
  },
  {
    filterKey: DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE,
    filterLabel: "Maximum Score",
    filterValue: filterData?.[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] ?? SCORE_FILTER.ONE_HUNDRED,
    filterOptions: [
      {
        optionValue: SCORE_FILTER.TWENTY,
        displayText: "20%",
      },
      {
        optionValue: SCORE_FILTER.FORTY,
        displayText: "40%",
      },
      {
        optionValue: SCORE_FILTER.SIXTY,
        displayText: "60%",
      },
      {
        optionValue: SCORE_FILTER.EIGHTY,
        displayText: "80%",
      },
      {
        optionValue: SCORE_FILTER.ONE_HUNDRED,
        displayText: "100%",
      },
    ],
  },
  // {
  //   filterKey: DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.AVG_SORT_ORDER,
  //   filterLabel: "Sort by",
  //   filterValue: AVG_SORT_ORDER.DEFAULT,
  //   filterOptions: [
  //     {
  //       optionValue: AVG_SORT_ORDER.DEFAULT,
  //       displayText: "None",
  //     },
  //     {
  //       optionValue: AVG_SORT_ORDER.HIGHER_THAN_AVERAGE,
  //       displayText: "Higher than average",
  //     },
  //     {
  //       optionValue: AVG_SORT_ORDER.LOWER_THAN_AVERAGE,
  //       displayText: "Lower than average",
  //     },
  //   ],
  // },
  // {
  //   filterKey: DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.DEPARTMENT,
  //   filterLabel: "Department",
  //   filterValue: DEPARTMENT_FILTER.ALL,
  //   filterOptions: [
  //     {
  //       optionValue: DEPARTMENT_FILTER.ALL,
  //       displayText: "All Games",
  //     },
  //   ],
  // },
]

const scoreForScoreFilter = (scoreFilter) => {
  let score = null
  switch (true) {
    case scoreFilter === SCORE_FILTER.ZERO:
      score = 0
      break
    case scoreFilter === SCORE_FILTER.TWENTY:
      score = 20
      break
    case scoreFilter === SCORE_FILTER.FORTY:
      score = 40
      break
    case scoreFilter === SCORE_FILTER.SIXTY:
      score = 60
      break
    case scoreFilter === SCORE_FILTER.EIGHTY:
      score = 80
      break
    case scoreFilter === SCORE_FILTER.ONE_HUNDRED:
      score = 100
      break
    default:
      break
  }
  return score
}

export const minimumScoreFromFilters = (filterData) => {
  const minScoreFilterValue = filterData?.[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] ?? SCORE_FILTER.ZERO
  return scoreForScoreFilter(minScoreFilterValue)
}

export const maximumScoreFromFilters = (filterData) => {
  const minScoreFilterValue = filterData?.[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] ?? SCORE_FILTER.ONE_HUNDRED
  return scoreForScoreFilter(minScoreFilterValue)
}

export const filterParamStringFromFilters = (filterData) => {
  let filterParam = ""
  Object.keys(filterData).forEach((filterKey) => {
    const filterVal = filterData[filterKey]
    if (filterVal && filterVal !== DEPARTMENT_FILTER.ALL && filterVal !== AVG_SORT_ORDER.DEFAULT) {
      filterParam += `${filterParam.length > 0 ? "&" : ""}${filterKey}=${filterData[filterKey]}`
    }
  })
  return filterParam
}

export const scoreFilterParamStringFromScoreRange = (scoreRangeKey) => {
  const filterData = {}
  switch (scoreRangeKey) {
    case DASHBOARD_OVERALL_SCORE_RANGES["0_19"]:
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] = SCORE_FILTER.ZERO
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] = SCORE_FILTER.TWENTY
      break
    case DASHBOARD_OVERALL_SCORE_RANGES["20_39"]:
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] = SCORE_FILTER.TWENTY
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] = SCORE_FILTER.FORTY
      break
    case DASHBOARD_OVERALL_SCORE_RANGES["40_59"]:
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] = SCORE_FILTER.FORTY
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] = SCORE_FILTER.SIXTY
      break
    case DASHBOARD_OVERALL_SCORE_RANGES["60_79"]:
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] = SCORE_FILTER.SIXTY
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] = SCORE_FILTER.EIGHTY
      break
    case DASHBOARD_OVERALL_SCORE_RANGES["80_100"]:
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE] = SCORE_FILTER.EIGHTY
      filterData[DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE] = SCORE_FILTER.ONE_HUNDRED
      break
    default:
      break
  }
  return filterParamStringFromFilters(filterData)
}

export const scoreFilterParamStringForAllScores = () => {
  return filterParamStringFromFilters({
    [DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE]: SCORE_FILTER.ZERO,
    [DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE]: SCORE_FILTER.ONE_HUNDRED,
  })
}
